import { generateImageUrl, generateProductUrl } from '@helpers/urlHelper';

export const renderTemplate = (html, replacements) => {
    let content = html;

    for (const key of Object.keys(replacements)) {
        const reg = new RegExp(`{{${key}}}`, 'gm');

        if (typeof replacements[key] !== 'undefined') {
            content = content.replace(reg, replacements[key]);
        }
    }

    content = content.replace(/{{([a-z]+)}}gm/, '');
    return content;
};

export const parseProducts = ({
    products, oos, templates, phrases
}) => {
    const currentNavId = document.body?.dataset?.navid || null;

    document
        .querySelectorAll('.cms-product-template__container:not(.cms-product-template__container--remove)')
        .forEach((containerElement) => {
            const alternateProducts = [];

            containerElement
                .querySelectorAll('.cms-product-template__item.product--alternate')
                .forEach((productElement) => {
                    const { fetchProduct } = productElement.dataset;
                    alternateProducts.push({ productID: fetchProduct.split('-')[0] });
                    productElement.parentNode.removeChild(productElement);
                });

            containerElement
                .querySelectorAll('.cms-product-template__item:not(.product--alternate)')
                .forEach((productElement) => {
                    const { fetchProduct, template: templateID } = productElement.dataset;
                    const [productID, eanID = 0] = fetchProduct.split('-');
                    let product = products[productID] || null;
                    let removeChild = false;
                    let isAlternate = false;

                    try {
                        if (eanID !== 0 && product?.eans && Array.isArray(product.eans)) {
                            const ean = product.eans.find(e => e.ean_id === eanID);

                            if (ean) {
                                product.filename = ean.filename;
                                product.ean_id = ean.ean_id;
                                product.actual_display_price = ean.actual_display_price;
                            }
                        }
                    } catch (e) {
                        // do nothing
                    }

                    if ((!product || typeof templates[templateID] === 'undefined') || (product && oos.includes(productID))) {
                        product = products?.[alternateProducts[0]?.productID] || null;

                        if (!product) {
                            removeChild = true;
                        } else {
                            isAlternate = true;
                        }
                    }

                    const imageSize = templateID === 'four' ? '1300x1700' : '400x523';
                    const {
                        productImage = '',
                        brandName = '',
                        brandSlug = '',
                        productSlug = ''
                    } = productElement.dataset;
                    const label = isAlternate ? `<span class="cms-product-template__image-header">
                                ${phrases['magazine.alt_product_label']}</span>` : '';

                    if (removeChild) {
                        const oosProduct = {
                            brand_slug: brandSlug,
                            product_slug: productSlug,
                            product_id: productID,
                            ean_id: eanID
                        };
                        const templateProps = {
                            label,
                            imgSrc: productImage,
                            imgAlt: brandName,
                            permalink: generateProductUrl(oosProduct),
                            brandName,
                            variantId: 0,
                            price: `<span class="cms-products-oos__info">${phrases['magazine.sold_out']}</span>`,
                            sizes: ''
                        };

                        productElement.innerHTML = `
                            <div class="cms-products-oos">
                                ${renderTemplate(templates[templateID], templateProps)}
                            </div>
                            `;
                    } else {
                        productElement.innerHTML = renderTemplate(templates[templateID], {
                            label: '',
                            imgSrc: generateImageUrl(product, imageSize, {}, true),
                            imgAlt: product.product_name,
                            permalink: generateProductUrl(product, {
                                group: currentNavId ? `product_${currentNavId}` : 'magazine'
                            }),
                            brandName: product.brand_name,
                            variantId: product.variant_id,
                            price: product.actual_display_price,
                            sizes: product?.sizes || ''
                        });
                    }
                });

            containerElement.classList.add('cms-product-template__container--ready');
        });
};
